import React, { useEffect } from "react";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import OrganizationDashboardApplications from "./components/OrganizationDashboardApplications";

const OrganizationDashboardPage = () => {
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle("Dashboard");
	}, []);

	return (
		<>
			<div className="content">
				<Header title={"Dashboard"} />
				<OrganizationDashboardApplications />
			</div>
		</>
	);
};

export default OrganizationDashboardPage;
